<template>
  <div class="item-base">
    <div class="item-sss">
      <el-input placeholder="搜索商品" class="input" v-model="name">
        <el-button slot="append" @click="GetData()"> <i class="el-icon-search"></i></el-button>
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductSearch",
  data(){
    return{
      name:null,
    }
  },
  methods:{
    GetData(){
      this.$axios.get('api/productInfo/getProductByNameLike',{params:{
        name : this.name
        }}).then(res=>{
        console.log(res);
        if(res.data.data){
          this.$message({
            message:'查找商品成功',
            type:'success'
          });
          this.$router.push('/product/'+res.data.data[0].id);
        }else {
          this.$message.error({
            message:'没有找到该商品'
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.item-base{
  height: 80px;
  background: #F6F7F8;
  display: flex;
  align-items: center;

  .item-sss{
    width: 74.5vw;
    margin: 0 auto;
  }
  .input{
    width: 600px;

  }

}
</style>